<script setup>
import { computed } from "vue";
import { useThemeStore } from "@/stores/themeStore";

const props = defineProps({
  label: { type: String, required: true },
  variant: { type: String, default: "primary" }, // primary or secondary
  type: { type: String, default: "button" }
});

const themeStore = useThemeStore();

const buttonStyle = computed(() => {
  if (!themeStore.theme) return {};

  const btn = themeStore.theme.theme.buttons[props.variant];
  return {
    backgroundColor: btn.background,
    color: btn.textColor
  };
});
</script>

<template>
  <button
    :type="type"
    :style="buttonStyle"
    class="px-4 py-2 cursor-pointer rounded hover:opacity-80 transition-all duration-300"
  >
    {{ label }}
  </button>
</template>
